import { z } from 'zod';
import { oneOf, pageNum, pageSize, str } from '../../navigation/searchParams';
import { topupReturnShape } from './topupReturnSearch';

/**
 * The ledger and per-agent tables (grouping, agent, paging), the credit-alerts
 * dialog, and the Stripe Checkout return of a top-up started here.
 */
export const usageSearch = z.object({
  ledgerGroup: oneOf(['day', 'week', 'month']),
  ledgerPage: pageNum,
  ledgerSize: pageSize,
  agentGroup: oneOf(['day', 'week', 'month', 'all']),
  agent: str,
  agentPage: pageNum,
  agentSize: pageSize,
  modal: oneOf(['credit-alerts']),
  ...topupReturnShape,
});
